import React from 'react'
import PropTypes from 'prop-types';
import Joyride, { ACTIONS, CallBackProps, EVENTS, STATUS, Step } from 'react-joyride';
import { connect } from 'react-redux';
import * as actionCreators from '../action_creators';
import { toJS } from '../helpers/toJS';
import { Project, mapProjectStateToProps } from './Project';
import clients from '../constants/clients';

export class Maker extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      walkthrough: false,
      stepIndex: 0,
      codeJoyride: true,
      editingFields: ['code'],
    }
  }

  getChildContext() {
    return { editingFields: this.state.editingFields }
  }

  canAutoFillPub() {
    return this.props.org && /[sS]cribe/.test(this.props.org);
  }

  suggestPublisherFromCode = (code) => {
    const pr = code.substring(0, 3).toLowerCase();
    return clients[pr];
  }

  suggestedPublisher = (code) => {
    if (this.canAutoFillPub()) {
      return this.suggestPublisherFromCode(code);
    } else {
      return this.props.org;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.id && this.props.id) {
      history.pushState({},null,`/wfdw/projects/${this.props.id}`);
      this.setState({
        codeJoyride: false,
        walkthrough: this.props.skipWizard ? false : true,
        editingFields: [],
      });
    }
  }

  updateProject = (id, attr, val) => {
    if (!this.props.code && attr === 'code') {
      this.props.createProject({
        code: val,
        publisher: this.suggestedPublisher(val)
      });
    } else {
      this.props.updateProject(id, attr, val);
    }
  }

  stepthrough = (stepObj) => {
    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(stepObj.type) && stepObj.action != ACTIONS.CLOSE ){
      this.setState({ stepIndex: stepObj.index + (stepObj.action === ACTIONS.PREV ? -1 : 1) });
    } else if (stepObj.status === STATUS.FINISHED) {
      window.location = `/wfdw/projects/${this.props.id}/uploader`;
    } else if (stepObj.action === ACTIONS.CLOSE) {
      this.setState({editingFields: [], walkthrough: false, stepIndex: 0});
    }
  }

  render() {
    return (
      <div className="app">
        <Joyride
          key='code-joyride'
          ref={c => (this.codeJoyride = c)}
          styles={{options: {zIndex: 1000}}}
          steps={[
            {
              title: 'Enter a project code.',
              content: `The project code is a unique identifier for your book
              project in the Hub. It is the only required field.
              Click the blue check mark or hit enter when ready.`,
              target: '#code-row',
              disableBeacon: true,
              disableOverlayClose: true,
              hideCloseButton: true,
              hideFooter: true,
              placement: 'top',
            },
          ]}
          locale={{last: null}}
          run={this.state.codeJoyride}
          disableOverlayClicks={true}
          disableOverlayClose={true}
          spotlightClicks={true}
          disableCloseOnEsc={true}
          hideCloseButton={true}
          scrollOffset={100}
        />
        <Joyride
          key='metadata-joyride'
          ref={c => (this.joyride = c)}
          styles={{options: {zIndex: 1000}}}
          disableOverlay={true}
          floaterProps={{ disableAnimation: true }}
          steps={[
            {
              title: 'Add other project metadata.',
              content: <div>
                <p>
                  To edit a field, click the "empty" text or the pencil button. Click the blue checkmark or hit enter when you are done with a field.
                </p>
                <p>
                  You can exit the project creation process at any time by clicking "Exit" or the X button.
                </p>
                <p>
                  Note: You will have the opportunity to upload files and set the project cover later in the process.
                </p>
              </div>,
              target: '#project-metadata',
              placement: 'right',
              disableBeacon: true,
            },
            {
              title: 'Add ISBNs',
              content: `Enter data for each ISBN type. \
              These are encouraged but not required.`,
              target: '#isbn-list',
              placement: 'right',
              disableBeacon: true,
            },
            {
              title: 'Add Creators',
              content: `Click “Add Creator” or “Add Contributor” and fill in the \
              fields to add either to the project. Add as many as you need.`,
              target: '#creators-list',
              placement: 'top',
              disableBeacon: true,
            },
          ]}
          locale={{
            back: 'Back',
            close: 'Close',
            last: 'Upload Files',
            next: 'Next',
            skip: 'Exit'
          }}
          showSkipButton={true}
          hideBackButton={false}
          showProgress={true}
          disableCloseOnEsc={true}
          run={this.state.walkthrough}
          stepIndex={this.state.stepIndex}
          spotlightClicks={true}
          scrollOffset={100}
          continuous
          callback={this.stepthrough}
        />
        <Project
          defaultTab={2}
          {...this.props}
          updateProject={this.updateProject}
        />
      </div>
    );
  }
}

Maker.childContextTypes = {
  editingFields: PropTypes.array
}

// combine with basic Project component state
function mapStateToProps(state) {
  return Object.assign(mapProjectStateToProps(state), {
    org: state.get('org'),
    skipWizard: state.get('skipWizard'),
  });
}

export const MakerContainer = connect(
    mapStateToProps,
    actionCreators,
)(toJS(Maker));
